import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './styles/global.css';
import { useToastStore } from '@/stores/toastStore';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

if ('serviceWorker' in navigator) {
  registerSW({
    onOfflineReady() {
      useToastStore.getState().addToast('success', 'オフラインでも利用できます', 3000);
    },
    onNeedRefresh() {
      useToastStore.getState().addToast('info', '新しいバージョンがあります。再読み込みしてください。', 5000);
    },
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
